import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Panel } from 'baseui/accordion';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { useResolvedStyle, mergeStyles } from '../../theme/utils.js';
import '../../theme/types.js';
import { mergeOverrides } from '../../overrides.js';
import { StyledToggleIcon } from './styled-components.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getOverrideStyle = (element) => ({ $theme, $expanded }) => {
  switch (element) {
    case "Header":
      return __spreadValues(__spreadProps(__spreadValues({}, $theme.typography.p2), {
        backgroundColor: "transparent",
        paddingTop: $theme.space[16],
        paddingRight: $theme.space[16],
        paddingBottom: $theme.space[16],
        paddingLeft: $theme.space[16],
        marginRight: `-${$theme.space[16]}`,
        marginLeft: `-${$theme.space[16]}`
      }), $expanded && {
        fontWeight: $theme.fontWeights.medium
      });
    case "Content":
      return {
        borderTopWidth: "1px",
        borderTopStyle: "solid",
        borderTopColor: $theme.colors["borders-global-tertiary"],
        paddingTop: $theme.space[16],
        paddingRight: 0,
        paddingBottom: $theme.space[16],
        paddingLeft: 0
      };
    case "PanelContainer":
      return {
        backgroundColor: "transparent",
        borderBottomColor: $theme.colors["borders-global-tertiary"],
        ":last-of-type": {
          borderBottomWidth: 0
        }
      };
    case "ToggleIcon":
      return {
        transform: $expanded ? "rotate(180deg)" : void 0,
        transition: `transform ${$theme.animation.duration[200]}`
      };
    default:
      return {};
  }
};
const AccordionPanel = forwardRef((_a, ref) => {
  var _b = _a, { $style, overrides } = _b, props = __objRest(_b, ["$style", "overrides"]);
  const resolvedStyles = useResolvedStyle($style);
  return jsx(Panel, __spreadValues({ ref, overrides: mergeOverrides({
    PanelContainer: {
      style: (styleProps) => mergeStyles(getOverrideStyle("PanelContainer")(styleProps), resolvedStyles)
    },
    Header: {
      style: getOverrideStyle("Header")
    },
    ToggleIcon: {
      style: getOverrideStyle("ToggleIcon"),
      component: StyledToggleIcon
    },
    ToggleIconGroup: {
      style: getOverrideStyle("ToggleIconGroup")
    },
    Content: {
      style: getOverrideStyle("Content")
    },
    ContentAnimationContainer: {
      style: getOverrideStyle("ContentAnimationContainer")
    }
  }, overrides) }, props));
});

export { AccordionPanel };
